export default __webpack_public_path__ + "static/media/firelevel.072f3f83.png";